// @react/hooks/useAuthn2FA.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { authn2FAStore } from '@core/stores';

/**
 * React hook for  operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useAuthn2FA } from '@react/hooks';
 *
 * const List = observer(() => {
 *   const store = useAuthn2FA();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useAuthn2FA() {
  return authn2FAStore;
}
